import { render, staticRenderFns } from "./SimpleImg.vue?vue&type=template&id=5cbce61e&scoped=true&"
import script from "./SimpleImg.vue?vue&type=script&lang=js&"
export * from "./SimpleImg.vue?vue&type=script&lang=js&"
import style0 from "./SimpleImg.vue?vue&type=style&index=0&id=5cbce61e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbce61e",
  null
  
)

export default component.exports